import { render, staticRenderFns } from "./BaseBTable.vue?vue&type=template&id=564ac5bc"
import script from "./BaseBTable.vue?vue&type=script&lang=js"
export * from "./BaseBTable.vue?vue&type=script&lang=js"
import style0 from "./BaseBTable.vue?vue&type=style&index=0&id=564ac5bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports